/* eslint-disable global-require */
/* eslint-disable max-len */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import extractYearAndMonth from 'lib/apps/catalogue/utils/extractYearAndMonth';
import { msg } from 'api';

class WelcomeSection extends Component {
  static propTypes = {
    userName: PropTypes.string.isRequired,
    userDayJoined: PropTypes.string.isRequired,
    numberDelivered: PropTypes.string.isRequired,
  };

  render() {
    const { userName, userDayJoined, numberDelivered } = this.props;
    const displayName = userName || '';
    const displayNumberDelivered = numberDelivered || '0';

    const { year, month } = extractYearAndMonth(userDayJoined);

    return (
      <section className="welcome-section">
        <div className="welcome-section__intro">
          <h2 className="welcome-section__title">
            {msg.yourSavingsHub.welcome.title}{' '}
            <span
              className="welcome-section__title-name"
              data-full-name={displayName.length > 14 ? displayName : null} // tooltip show full name if it's longer than 14 characters
            >
              <span className="welcome-section__title-name-text">{displayName}</span>
            </span>
          </h2>
          <p className="welcome-section__description">
            {msg.yourSavingsHub.welcome.messages.welcomeMessage}
          </p>
        </div>
        <div className="welcome-section__card">
          <div className="welcome-section__card-content">
            <div className="welcome-section__icon-text">
              <img className="welcome-section__icon" src={require('themes/ocado/assets/images/icons/ysh/grape_account.svg')} alt="icon" />
              <p className="welcome-section__text">{msg.yourSavingsHub.welcome.messages.shoppingSince}</p>
            </div>
            <div className="welcome-section__inner">
              <p className="welcome-section__joined">{month}</p>
              <p className="welcome-section__day-joined">{year}</p>
            </div>
          </div>
          <div className="welcome-section__card-content">
            <div className="welcome-section__icon-text">
              <img className="welcome-section__icon" src={require('themes/ocado/assets/images/icons/ysh/grape_trolley.svg')} alt="icon" />
              <p className="welcome-section__text">{msg.yourSavingsHub.welcome.messages.shopsDelivered}</p>
            </div>
            <div className="welcome-section__inner">
              <p className="welcome-section__number-delivered">{displayNumberDelivered}</p>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default WelcomeSection;
